import { render, staticRenderFns } from "./ManageAcademyEvent.vue?vue&type=template&id=c06cbe28&scoped=true"
import script from "./ManageAcademyEvent.vue?vue&type=script&lang=js"
export * from "./ManageAcademyEvent.vue?vue&type=script&lang=js"
import style0 from "./ManageAcademyEvent.vue?vue&type=style&index=0&id=c06cbe28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06cbe28",
  null
  
)

export default component.exports